import { useState } from 'react';
import { Input } from './input';

import { Eye, EyeOff } from 'lucide-react';

export function PasswordInput({
  id,
  name,
  value,
  onChange,
  autoComplete,
  placeholder = '••••••••',
  className = '',
  ariaLabelShow,
  ariaLabelHide,
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative">
      <Input
        id={id}
        name={name}
        type={showPassword ? 'text' : 'password'}
        autoComplete={autoComplete}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoCorrect="off"
        spellCheck={false}
        className={`
          h-12 pr-12
          [&::-ms-reveal]:hidden
          [&::-ms-clear]:hidden
          ${className}
        `}
      />

      <button
        type="button"      
        onClick={() =>
          setShowPassword((prev) => !prev)
        }
        className="
          absolute right-4 top-1/2 -translate-y-1/2
          text-indigo-500 hover:text-blue-600
          transition-all duration-200
          cursor-pointer
          bg-transparent border-0
        "
        aria-label={
          showPassword
            ? ariaLabelHide
            : ariaLabelShow
        }
      >
       {showPassword ? (
            <EyeOff
              strokeWidth={2.3}
              className="
                h-5 w-5 transition-all duration-200
              "
            />
          ) : (
            <Eye
              strokeWidth={2.3}
              className="
                h-5 w-5 transition-all duration-200
              "
            />
          )}
      </button>
    </div>
  );
}

